<template>
  <v-container>
    <p class="step-title">{{ $t('employerStep.title') }}</p>
    <HfrCard v-if="userInfo && Object.keys(userInfo).length > 0">
      <div class="field-warning mb-0">{{ $t('global.prefilledDataWarning') }} </div>
    </HfrCard>
    <HfrCard>
      <v-form ref="employerForm">
        <v-checkbox
          v-model="form.noEmployer"
          :label="$t('employerStep.noEmployer')"></v-checkbox>
        <div v-if="form.noEmployer !== true">
          <v-text-field
            v-model="form.name"
            :label="$t('employerStep.name')"
            filled
            class="required"
            :rules="form.noEmployer !== true ? [rules.required] : []"
            :disabled="form.noEmployer">
          </v-text-field>
          <v-text-field
            v-model="form.employerName"
            :label="$t('employerStep.employerName')"
            filled
            class="required"
            :rules="form.noEmployer !== true ? [rules.required] : []"
            :disabled="form.noEmployer">
          </v-text-field>
          <v-text-field
            v-model="form.employerZip"
            :label="$t('global.zip')"
            filled
            :disabled="form.noEmployer">
          </v-text-field>
          <v-text-field
            v-model="form.employerCity"
            :label="$t('global.city')"
            filled
            :disabled="form.noEmployer">
          </v-text-field>
        </div>
      </v-form>
    </HfrCard>
  </v-container>
</template>
<script>
import HfrCard from '../ui/HfrCard.vue';
import { parseDate } from '@/helpers/dates';
import { mapActions, mapState } from 'vuex';
import { requiredRule } from '@/helpers/validationRules';
export default {
  name: 'EmployerStep',
  data() {
    return {
      form: {
        noEmployer: null,
        name: process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'Rocker' : null,
        employerName:
          process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'Foo Fighters' : null,
        employerZip:
          process.env.VUE_APP_PREFILL_FORMS === 'true' ? '9979' : null,
        employerCity:
          process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'San Fransisco' : null
      },
      rules: {
        required: requiredRule
      },
      stepNumber: 5
    };
  },
  components: { HfrCard },
  watch: {
    userInfo: {
      handler() {
        this.fillFormDataWithUserInfo();
      }
    },
    navigateToNextStep: {
      handler(navigateToNextStep) {
        if (this.currentStep === this.stepNumber && navigateToNextStep) {
          this.validateEmployerForm();
        }
      }
    }
  },
  methods: {
    ...mapActions('navigation', [
      'setFormValidity',
      'doNextStep',
      'toggleNavigateToNextStep'
    ]),
    ...mapActions('preAdmission', ['storeEmployerStep']),
    doParseDate(date) {
      parseDate(date);
    },
    fillFormDataWithUserInfo() {
      const infos = this.userInfo?.patient?.job;
      this.form.noEmployer = null
      if (infos) {
        this.form.name = infos.name
        this.form.employerName = infos.employer_name
        this.form.employerZip = infos.employer_zip_code
        this.form.employerCity = infos.employer_city
      } else {
        this.$refs.employerForm.reset();
      }
      this.$refs.employerForm.resetValidation();
    },
    validateEmployerForm() {
      if (this.$refs.employerForm.validate()) {
        this.storeEmployerStep(this.form);
        this.doNextStep();
      }
      this.toggleNavigateToNextStep();
    }
  },
  computed: {
    ...mapState('preAdmission', ['userInfo']),
    ...mapState('navigation', ['navigateToNextStep', 'currentStep'])
  }
};
</script>
